const initialState = {
  isFetching: false,
  isFetched: false,
  page: 1,
  items: 16,
  total: 0,
  list: [],
};

const reducer = (state = initialState, action) => {
  const {type, payload} = action;

  switch (type) {
    case 'RESUME/CATALOG_LIST_REQUEST':
      return {...state, isFetching: true, isFetched: false};
    case 'RESUME/CATALOG_LIST_FAILURE':
      return {...state, isFetching: false, isFetched: false};
    case 'RESUME/CATALOG_LIST_SUCCESS':
      return {
        ...state, isFetching: false, isFetched: true, page: payload.page, list: [...payload.resumes], total: payload.total,
      };

    case 'RESUME/RESET':
    case 'RESUME/CATALOG_RESET':
      return initialState;
    default:
      return state;
  };
};

export default reducer;